import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { catchError } from 'rxjs/operators';
import {
  Resolve,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  Router,
} from '@angular/router';

import { AdminsApiService } from '../../api';
import { LoginAlertService } from '../login-alert.service';

@Injectable()
export class AdminResolve implements Resolve<any> {
  constructor(
    private router: Router,
    private adminService: AdminsApiService,
    private alertService: LoginAlertService
  ) {}

  resolve(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<any> {
    return this.adminService.checkToken({ token: route.params.token }).pipe(
      catchError(() => {
        this.alertService.setAlert({
          type: 'error',
          message: 'Invalid or expired token.',
        });
        this.router.navigateByUrl('/login');

        return of(false);
      })
    );
  }
}
